class ProductMedia extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      slider: '#product-media-gallery',
      thumbs: '.product__media-thumbs',
      mediaItem: '[data-media-id]',
      modalOpeners: '[data-modal-opener-id]',
      zoomImages: '[data-pswp-image]',
      btnXr: '[data-shopify-xr]'
    };
    this.selectedMediaIndex =
      Number(
        this.querySelector(this.selectors.slider).querySelector(
          '[data-selected]'
        )?.dataset.index
      ) || 0;

    const swiperOptions = JSON.parse(
      this.querySelector(this.selectors.slider).getAttribute(
        'data-swiper-options'
      )
    );

    if (Shopify.designMode) {
      this.addEventListener('shopify:section:load', event => {
        this.init();
      });
    }
    const withThumbs = this.dataset.withThumbs;

    if (withThumbs === 'true') {
      let setWrapperStyles = function (swiper) {
        let wrapperCenterClass = 'swiper-wrapper__center';
        let buttonDisabledClass = swiper.params.buttonDisabledClass;
        let wrapperEl = swiper.wrapper[0];

        if (
          swiper.prevButton[0].classList.contains(
            buttonDisabledClass
          ) &&
          swiper.nextButton[0].classList.contains(buttonDisabledClass)
        ) {
          // center slides
          wrapperEl.classList.add(wrapperCenterClass);
        } else {
          wrapperEl.classList.remove(wrapperCenterClass);
        }
      };
    }

    const mainGalleryEl = this.querySelector(this.selectors.slider);
    const totalSlides = mainGalleryEl
      ? mainGalleryEl.querySelectorAll('.swiper-slide').length
      : 0;
    const isSingleSlide = totalSlides <= 1;

    const prevButton = this.querySelector(
      '#product-media-gallery .swiper-button--prev'
    );
    const nextButton = this.querySelector(
      '#product-media-gallery .swiper-button--next'
    );
    const hasGalleryNav = Boolean(prevButton && nextButton);

    this.settings = {
      sliderElement: this.querySelector(this.selectors.slider),
      sliderInstance: null,
      options: {
        initialSlide: this.selectedMediaIndex,
        navigation:
          isSingleSlide || !hasGalleryNav
            ? false
            : {
                prevEl: prevButton,
                nextEl: nextButton
              },

        pagination:
          isSingleSlide || withThumbs === 'true'
            ? false
            : {
                el: this.querySelector(
                  '#product-media-gallery .swiper-pagination'
                ),
                type: 'progressbar'
              },

        spaceBetween: withThumbs === 'true' ? 0 : 2,
        watchOverflow: !isSingleSlide,
        allowTouchMove: !isSingleSlide,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        preventInteractionOnTransition: true,

        /* 缩略图画廊用 CSS 自然高度；autoHeight 会与 ResizeObserver 互相触发导致高度跳动 */
        autoHeight:
          this.dataset.withThumbs !== 'true' &&
          this.dataset.autoHeight === 'true',

        on: {
          afterInit: swiper => {
            const isSwiperGenerated =
              swiper.slides.length > 1 ? true : false;

            if (isSwiperGenerated) {
              const firstSlide = swiper.slides[0];

              const firstSlideVideo =
                firstSlide.querySelector('video');

              if (firstSlideVideo) {
                this.playPromise(firstSlideVideo);
              }

              // if firstSlide has youtube, play it
              const firstSlideYoutube =
                firstSlide.querySelector('.js-youtube');
              if (firstSlideYoutube) {
                this.playYoutubeVideo(firstSlideYoutube);
              }

              // if firstSlide has vimeo, play it
              const firstSlideVimeo =
                firstSlide.querySelector('.js-vimeo');
              if (firstSlideVimeo) {
                this.playVimeoVideo(firstSlideVimeo);
              }
            }
          },

          slideChangeTransitionEnd: swiper => {
            this.setActiveModalOpener(swiper);
          },
          transitionStart: swiper => {
            const videos = swiper.el.querySelectorAll('video');
            Array.from(videos).forEach(video => {
              video.pause();
            });
          },
          slideChange: swiper => {
            if (
              window.innerWidth >= 990 &&
              this.dataset.withThumbs !== 'true'
            ) {
              const previousIndex = swiper.previousIndex;
              const activeIndex = swiper.activeIndex;

              const prevButton = this.querySelector(
                '.swiper-button.swiper-button--prev'
              );
              const swiperContainer = this.querySelector(
                '#product-media-gallery'
              );

              if (prevButton) {
                prevButton.addEventListener('click', () => {
                  if (swiperContainer) {
                    swiperContainer.style.marginInlineStart = '0';
                  }
                });
              }

              if (swiperContainer) {
                swiperContainer.style.marginInlineStart = '0';
              }

              if (previousIndex > activeIndex && swiperContainer) {
                swiperContainer.style.marginInlineStart = '0';
              }
            }
          },
          transitionEnd: swiper => {
            const isSwiperGenerated =
              swiper.slides.length > 1 ? true : false;

            if (isSwiperGenerated) {
              let slideIndex = swiper.activeIndex;

              const swiperCardWidth = swiper.slides[0].offsetWidth;

              slideIndex = Math.abs(
                Math.floor(swiper.translate / [swiperCardWidth])
              );

              const activeSlide = Array.from(swiper.slides).find(
                sliderSlide =>
                  sliderSlide.classList.contains(
                    'swiper-slide-active'
                  )
              );

              // play or pause videos in active and next slides
              const activeSlideVideo =
                activeSlide.querySelector('video');
              const nextSlideVideo =
                activeSlide.nextElementSibling?.querySelector(
                  'video'
                );

              const playVideo = video => {
                if (video && video.paused) {
                  this.playPromise(video);
                } else if (video) {
                  video.pause();
                }
              };

              playVideo(activeSlideVideo);
              playVideo(nextSlideVideo);

              const activeSlideYoutube =
                activeSlide.querySelector('.js-youtube');
              if (activeSlideYoutube) {
                this.playYoutubeVideo(activeSlideYoutube);
              }

              const activeSlideVimeo =
                activeSlide.querySelector('.js-vimeo');
              if (activeSlideVimeo) {
                this.playVimeoVideo(activeSlideVimeo);
              }
            }
          }
        }
      }
    };

    const thumbsElement = this.querySelector(this.selectors.thumbs);

    if (withThumbs === 'true' && thumbsElement) {
      this.settings.options.slidesPerView = 1;
      this.settings.options.spaceBetween = 0;
      this.settings.options.centeredSlides = false;
      const thumbsScrollbar = thumbsElement.querySelector(
        '.product__media-thumbs-scrollbar'
      );
      const thumbSettings = {
        swiper: {
          el: thumbsElement,

          initialSlide: this.selectedMediaIndex,

          centeredSlides: false,
          centeredSlidesBounds: false,
          slideToClickedSlide: true,
          freeMode: {
            enabled: true,
            sticky: true
          },
          direction: 'horizontal',

          slidesPerView: 'auto',
          spaceBetween: 12,

          threshold: 5,

          watchOverflow: !isSingleSlide,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,

          scrollbar: thumbsScrollbar
            ? {
                el: thumbsScrollbar,
                draggable: true,
                hide: true
              }
            : undefined,

          breakpoints: {
            0: {
              direction: 'horizontal',
              slidesPerView: 'auto',
              spaceBetween: 12,
              freeMode: {
                enabled: true,
                sticky: false
              }
            },
            750: {
              direction: swiperOptions.thumbsDirectionDesktop || 'vertical',
              spaceBetween: 12,
              slidesPerView: 6,
              freeMode: {
                enabled: true,
                sticky: true
              }
            }
          },

          on: {
            touchEnd: function (s, e) {
              let range = 5;
              let diff = (s.touches.diff = s.isHorizontal()
                ? s.touches.currentX - s.touches.startX
                : s.touches.currentY - s.touches.startY);
              if (diff < range || diff > -range) s.allowClick = true;
            },
            afterInit: () => {
              thumbsElement?.classList.add('swiper-thumbs--visible');
            }
          }
        }
      };

      this.settings.options.thumbs = thumbSettings;

      /* 缩略图模式主轮播始终单张全宽，不用 breakpoints（避免与 slide 宽度计算冲突） */
      delete this.settings.options.breakpoints;

      // Add the thumbs-specific event handlers
      this.settings.options.on.init = swiper => {
        if (swiper.thumbs?.swiper?.el) {
          swiper.thumbs.swiper.el.classList.add('swiper-thumbs--visible');
        }
      };

      const mainAfterInit = this.settings.options.on.afterInit;
      this.settings.options.on.afterInit = swiper => {
        if (typeof mainAfterInit === 'function') {
          mainAfterInit.call(this, swiper);
        }
      };

      this.settings.options.on.slideChangeTransitionStart =
        swiper => {
          const thumbsSwiper = swiper.thumbs.swiper;
          const activeIndex = swiper.activeIndex;
          const thumbsActiveIndex = thumbsSwiper.activeIndex;
          if (activeIndex !== thumbsActiveIndex) {
            thumbsSwiper.slideTo(activeIndex);
          }
        };

      const thumbsSlideChangeEnd =
        this.settings.options.on.slideChangeTransitionEnd;
      this.settings.options.on.slideChangeTransitionEnd = swiper => {
        if (typeof thumbsSlideChangeEnd === 'function') {
          thumbsSlideChangeEnd.call(this, swiper);
        }
        this.scheduleGalleryLayoutRefresh();
      };
    } else {
      const slideCount = this.settings.sliderElement.querySelectorAll(
        '.swiper-slide'
      ).length;
      if (slideCount === 1) {
        this.settings.options.breakpoints = {
          1000: {
            slidesPerView: 0.6
          }
        };
      } else {
        this.settings.options.slidesPerView = 1;
        this.settings.options.breakpoints = {
          1000: {
            slidesPerView: 1
          },
          1350: {
            slidesPerView: 1
          },
          1920: {
            slidesPerView: 1
          }
        };
      }
    }
  }

  playPromise(video) {
    let playPromise = video.play();
    if (playPromise !== undefined) {
      playPromise
        .then(() => {
          // Automatic playback started!
          // Show playing UI.
          // video.play();
        })
        .catch(error => {
          // Auto-play was prevented
          // Show paused UI.
          video.pause();
        });
    }
  }

  playYoutubeVideo(element) {
    element.contentWindow.postMessage(
      '{"event":"command","func":"' + 'playVideo' + '","args":""}',
      '*'
    );
  }

  playVimeoVideo(element) {
    element.contentWindow.postMessage('{"method":"play"}', '*');
  }

  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    this.unbindGalleryResponsiveRefresh();
  }

  bindGalleryResponsiveRefresh() {
    if (this._galleryResponsiveBound || this.dataset.withThumbs !== 'true') {
      return;
    }
    this._galleryResponsiveBound = true;

    this._desktopMediaQuery = window.matchMedia('(min-width: 750px)');
    this._onGalleryResponsiveChange = () => this.scheduleGalleryLayoutRefresh();

    window.addEventListener('resize', this._onGalleryResponsiveChange);
    window.addEventListener('orientationchange', this._onGalleryResponsiveChange);
    this._desktopMediaQuery.addEventListener(
      'change',
      this._onGalleryResponsiveChange
    );

    if (typeof ResizeObserver !== 'undefined') {
      const galleryMain = this.querySelector('.product__media-gallery-main');
      if (galleryMain) {
        this._lastGalleryHeight = 0;
        this._galleryResizeObserver = new ResizeObserver(entries => {
          if (window.innerWidth < 750) return;

          const height = entries[0]?.contentRect?.height;
          if (!height || Math.abs(height - this._lastGalleryHeight) < 2) {
            return;
          }
          this._lastGalleryHeight = height;
          this.scheduleGalleryLayoutRefresh();
        });
        this._galleryResizeObserver.observe(galleryMain);
      }
    }
  }

  unbindGalleryResponsiveRefresh() {
    if (this._onGalleryResponsiveChange) {
      window.removeEventListener('resize', this._onGalleryResponsiveChange);
      window.removeEventListener(
        'orientationchange',
        this._onGalleryResponsiveChange
      );
      this._desktopMediaQuery?.removeEventListener(
        'change',
        this._onGalleryResponsiveChange
      );
      this._onGalleryResponsiveChange = null;
    }

    this._galleryResizeObserver?.disconnect();
    this._galleryResizeObserver = null;
    this._desktopMediaQuery = null;
    this._galleryResponsiveBound = false;

    if (this._layoutRefreshTimer) {
      clearTimeout(this._layoutRefreshTimer);
      this._layoutRefreshTimer = null;
    }
  }

  scheduleGalleryLayoutRefresh() {
    if (this.dataset.withThumbs !== 'true') return;

    if (this._layoutRefreshTimer) {
      clearTimeout(this._layoutRefreshTimer);
    }

    this._layoutRefreshTimer = setTimeout(() => {
      this._layoutRefreshTimer = null;
      this.refreshThumbsGalleryLayout({ full: false });
    }, 200);
  }

  resetThumbsGalleryInlineStyles() {
    const gallery = this.querySelector('#product-media-gallery');

    if (gallery) {
      gallery.style.marginInlineStart = '';
      gallery.style.width = '';
    }
  }

  getMainGalleryHeight() {
    const mainGallery = this.querySelector('#product-media-gallery');
    const galleryMain = this.querySelector('.product__media-gallery-main');
    if (!mainGallery) return 0;

    const activeSlide =
      mainGallery.querySelector('.swiper-slide-active') ||
      mainGallery.querySelector('.swiper-slide');
    const activeMedia = activeSlide?.querySelector(
      '.media:not(.media--thumb)'
    );
    const activeImg = activeMedia?.querySelector('img');

    if (activeImg?.offsetHeight > 0) {
      return activeImg.offsetHeight;
    }
    if (activeMedia?.offsetHeight > 0) {
      return activeMedia.offsetHeight;
    }
    if (galleryMain?.offsetHeight > 0) {
      return galleryMain.offsetHeight;
    }

    return mainGallery.offsetHeight;
  }

  clearThumbsGalleryColumnHeights() {
    const thumbsCol = this.querySelector('.product__media-thumbs-col');
    const thumbsSwiperEl = this.querySelector(this.selectors.thumbs);

    [thumbsCol, thumbsSwiperEl].forEach(el => {
      if (!el) return;
      el.style.height = '';
      el.style.maxHeight = '';
    });
  }

  applyThumbsGalleryHeight() {
    if (this.dataset.withThumbs !== 'true') return;

    const galleryMain = this.querySelector('.product__media-gallery-main');
    const thumbsCol = this.querySelector('.product__media-thumbs-col');
    const thumbsSwiperEl = this.querySelector(this.selectors.thumbs);

    if (!thumbsCol || !thumbsSwiperEl) return;

    if (window.innerWidth < 750) {
      this.clearThumbsGalleryColumnHeights();
      return;
    }

    const mainHeight =
      galleryMain?.offsetHeight || this.getMainGalleryHeight();
    if (mainHeight < 1) return;

    const heightPx = `${mainHeight}px`;
    if (
      thumbsCol.style.height === heightPx &&
      thumbsSwiperEl.style.height === heightPx
    ) {
      return;
    }

    thumbsCol.style.height = heightPx;
    thumbsCol.style.maxHeight = 'none';
    thumbsSwiperEl.style.height = heightPx;
    thumbsSwiperEl.style.maxHeight = 'none';

    const thumbsSwiper = this.settings.sliderInstance?.thumbs?.swiper;
    if (thumbsSwiper) {
      thumbsSwiper.updateSize();
    }
  }

  refreshThumbsGalleryLayout({ full = true } = {}) {
    if (this.dataset.withThumbs !== 'true') return;

    const finishLayout = () => {
      if (window.innerWidth < 750) {
        this.clearThumbsGalleryColumnHeights();
        this.fixThumbsMobileStrip();
      } else {
        this.fixThumbsDesktopStrip();
        this.applyThumbsGalleryHeight();
      }
    };

    if (full) {
      this.resetThumbsGalleryInlineStyles();
      this.fixThumbsMainGallery(finishLayout);
    } else {
      finishLayout();
    }
  }

  syncThumbsGalleryHeight() {
    if (this.dataset.withThumbs !== 'true') return;

    const mainGallery = this.querySelector('#product-media-gallery');
    if (!mainGallery) return;

    this.bindGalleryResponsiveRefresh();
    this.refreshThumbsGalleryLayout({ full: true });

    mainGallery.querySelectorAll('img').forEach(img => {
      if (!img.complete) {
        img.addEventListener(
          'load',
          () => this.scheduleGalleryLayoutRefresh(),
          { once: true }
        );
      }
    });
  }

  init() {
    const [
      zoomContainerWidth,
      zoomContainerHeight,
      closeIcon,
      prevIcon,
      nextIcon
    ] = [
      this.offsetWidth,
      this.offsetHeight,
      this.querySelector('[data-close-icon]'),
      this.querySelector('[data-prev-icon]'),
      this.querySelector('[data-next-icon]')
    ];

    function isPhone() {
      return window.innerWidth < 750;
    }

    const photoSwipeLightboxInstance = new PhotoSwipeLightbox({
      gallery: `#${this.settings.sliderElement.id}`,
      // appendToEl: this.querySelector(this.selectors.zoomContainer),
      children: 'a',
      mainClass: 'pswp--product-media-gallery',

      loop: false,
      showHideAnimationType: 'zoom',

      initialZoomLevel: zoomLevelObject => {
        if (isPhone()) {
          return zoomLevelObject.vFill;
        } else {
          return zoomLevelObject.fit;
        }
      },
      secondaryZoomLevel: zoomLevelObject => {
        if (isPhone()) {
          return zoomLevelObject.fit;
        } else {
          return 1;
        }
      },
      pswpModule: PhotoSwipe
    });
    photoSwipeLightboxInstance.addFilter(
      'uiElement',
      (element, data) => {
        if (data.name === 'close') {
          element.innerHTML = closeIcon.innerHTML;
        } else if (data.name === 'arrowPrev') {
          element.innerHTML = prevIcon.innerHTML;
        } else if (data.name === 'arrowNext') {
          element.innerHTML = nextIcon.innerHTML;
        }
        return element;
      }
    );

    // html for video
    photoSwipeLightboxInstance.addFilter(
      'itemData',
      (itemData, index) => {
        if (itemData.type === 'html' && itemData.element) {
          return {
            html: itemData.element.dataset.pswpHtml
          };
        }
        return itemData;
      }
    );

    photoSwipeLightboxInstance.init();

    photoSwipeLightboxInstance.on('beforeOpen', () => {
      const videos = this.querySelectorAll('video');
      Array.from(videos).forEach(video => {
        // if video is not playing, call playPromise
        // force to play
        video.play().then(() => {
            // Automatic playback started!
            // Show playing UI.
            // video.play();
          }).catch(error => {
            // Auto-play was prevented
            // Show paused UI.
            video.pause();
          });

      });
    });

    this.addEventListener('dragstart', event => {
      event.preventDefault();
    });

    if (!this.settings.sliderElement) return;

    this.settings.sliderInstance = new Swiper(
      this.settings.sliderElement,
      this.settings.options
    );

    if (this.dataset.withThumbs === 'true') {
      this.syncThumbsGalleryHeight();
    }
  }

  fixThumbsMainGallery(done) {
    const swiper = this.settings.sliderInstance;
    const gallery = this.querySelector('#product-media-gallery');
    if (!swiper || !gallery) {
      if (typeof done === 'function') done();
      return;
    }

    swiper.params.slidesPerView = 1;
    swiper.params.spaceBetween = 0;
    swiper.params.centeredSlides = false;
    swiper.slideTo(swiper.activeIndex, 0, false);

    const runUpdate = () => {
      swiper.updateSize();
      swiper.updateSlides();
      swiper.update();
    };

    requestAnimationFrame(() => {
      runUpdate();
      requestAnimationFrame(() => {
        if (typeof done === 'function') done();
      });
    });
  }

  fixThumbsDesktopStrip() {
    if (window.innerWidth < 750) return;

    const thumbsSwiper = this.settings.sliderInstance?.thumbs?.swiper;
    const thumbsEl = this.querySelector(this.selectors.thumbs);
    if (!thumbsSwiper || !thumbsEl) return;

    const slideCount = thumbsSwiper.slides?.length || 0;
    const visibleCount = Math.min(6, Math.max(slideCount, 1));

    if (thumbsSwiper.params.direction !== 'vertical') {
      thumbsSwiper.changeDirection('vertical', true);
    }

    thumbsSwiper.params.slidesPerView = visibleCount;
    thumbsSwiper.params.spaceBetween = 12;

    thumbsSwiper.updateSize();
    thumbsSwiper.updateSlides();
    thumbsSwiper.update();
  }

  fixThumbsMobileStrip() {
    if (window.innerWidth >= 750) return;

    const thumbsSwiper = this.settings.sliderInstance?.thumbs?.swiper;
    const thumbsCol = this.querySelector('.product__media-thumbs-col');
    const thumbsEl = this.querySelector(this.selectors.thumbs);
    if (!thumbsSwiper || !thumbsEl) return;

    const thumbSize = 'var(--product-mobile-thumb-size, 6.4rem)';

    this.clearThumbsGalleryColumnHeights();

    if (thumbsSwiper.params.direction !== 'horizontal') {
      thumbsSwiper.changeDirection('horizontal', true);
    }

    thumbsSwiper.params.slidesPerView = 'auto';
    thumbsSwiper.params.spaceBetween = 12;
    thumbsSwiper.params.freeMode = { enabled: true, sticky: false };

    if (thumbsCol) {
      thumbsCol.style.height = thumbSize;
      thumbsCol.style.maxHeight = thumbSize;
    }
    thumbsEl.style.height = thumbSize;
    thumbsEl.style.maxHeight = thumbSize;

    thumbsSwiper.updateSize();
    thumbsSwiper.updateSlides();
    thumbsSwiper.update();
  }

  setActiveMedia(id) {
    const mediaFound = Array.from(
      this.querySelectorAll(this.selectors.mediaItem)
    ).find(media => Number(media.dataset.mediaId) === id);
    if (!mediaFound) return;
    this.settings.sliderInstance.slideTo(
      Number(mediaFound.dataset.index)
    );
  }

  setActiveModalOpener(swiper) {
    const activeSlide = swiper.slides.filter(sliderSlide =>
      sliderSlide.classList.contains('swiper-slide-active')
    )[0];
    if (!activeSlide) return;
    const activeMediaId = activeSlide.dataset.mediaId;
    this.querySelector(
      `${this.selectors.modalOpeners}.is-active`
    )?.classList.remove('is-active');
    this.querySelector(
      `${this.selectors.modalOpeners} [data-media-id="${activeMediaId}"]`
    )?.parentElement.classList.add('is-active');
    const isModel = activeSlide.dataset.mediaType === 'model';
    if (!isModel) return;
    const btnXr = this.querySelector(this.selectors.btnXr);
    btnXr.dataset.shopifyModel3dId = activeMediaId;
  }
}

customElements.define('product-media', ProductMedia);
